import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  navbar: {
    backgroundColor: 'white',
    boxShadow: '0 24px 24px -24px rgba(6, 31, 128, 0.2)',
    padding: '10px 30px',
    height: 72,
  },
  img: {
    width: 120,
    height: 40,
  },
  titulo: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 18,
    fontWeight: 600,
    color: '#5e5e85',
    marginLeft: 20,
  },
  logoSebrae: {
    width: 75,
    height: 40,
    marginLeft: '91px',
  },
  espacamento: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  menuIcon: {
    color: '#061f80',
    fontSize: 36,
    marginRight: 15,
    cursor: 'pointer',
  },
  itens: {
    fontFamily: 'IBM Plex Sans',
    fontSize: 16,
    fontWeight: 500,
    color: '#5e6784',
    listStyle: 'none',
    margin: 0,
    padding: '10px 0',
  },
  icon: {
    marginRight: '9px',
    color: '#00a6ff',
  },
  backgroundAzul: {
    backgroundColor: '#30b0ff',
  },
}));

export default useStyles;
